enum ViewType{
	list,
	grid,
	flex,
	playlist
}